import {
  DashboardAdvanceInput,
  DashboardDivisor,
  DashboardhMediumButton,
} from 'bd-web-components'
import {
  CenterTextDiv,
  ControlFooterDiv,
  AmountMobileDiv,
  MobileTarrifDiv,
  ResultText,
  ResultValueText,
  AdvanceMobileBox,
  ErrorMessage,
  MobileContainer,
  MobileInputBox,
  AvaliableValueText,
  AvaliableValueTextBold,
  TermsAndConditionLabel,
  TermsAndConditionInput,
  TermsAndConditionTextBox,
  TermsAndConditionText,
  TermsAndConditionLink,
  AdvanceControlsMobileBox,
  SimulationMobileBox,
  AdvanceControlMobileBox,
} from './advance-style'
import {
  GRAY_SCALE_08,
  PRIMARY_RED_01,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
import Loader from '../../components/Loader'
import { getDashColor } from '../../styles'

export const AdvanceMobile = ({
  useFormikProps,
  advanceLimitFormatted,
  isError,
  totalAdvanced,
  isSimulation,
  priceOfAdvance,
  advanceTariff,
  disabledControl,
  loading,
  setIsSimulation,
  disabledAdvanceControl,
  setIsTermModal,
}: any) => {
  return (
    <MobileContainer>
      <AdvanceMobileBox>
        <AmountMobileDiv>
          <AvaliableValueText>
            {'Disponível para antecipação:'}
          </AvaliableValueText>
          <br />
          <AvaliableValueTextBold>
            {advanceLimitFormatted}
          </AvaliableValueTextBold>
        </AmountMobileDiv>
        <MobileInputBox>
          <DashboardAdvanceInput
            type={'text'}
            error={isError}
            name={'totalAdvancedRequested'}
            title={'Antecipar'}
            value={useFormikProps.values.totalAdvancedRequested}
            onChange={(e: any) => {
              useFormikProps.setFieldValue(
                'totalAdvancedRequested',
                e.target.value
              )
            }}
            onBlur={useFormikProps.handleBlur}
            placeholder={'000'}
            disabled={!isSimulation}
          />
          <DashboardDivisor
            marginTop={29}
            marginBottom={19}
            marginTopMobile={8}
            marginBottomMobile={16}
            color={isError ? PRIMARY_RED_01 : GRAY_SCALE_08}
          />
          <ErrorMessage error={isError}>
            {useFormikProps.errors.totalAdvancedRequested}
          </ErrorMessage>
        </MobileInputBox>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '30px',
            marginTop: '5px',
          }}
        >
          <ResultText>Receber</ResultText>
          <ResultValueText>
            {useFormikProps.values.totalAdvanced}
          </ResultValueText>
        </div>
        <CenterTextDiv>
          <MobileTarrifDiv>
            <AvaliableValueText>Taxa Efetiva:</AvaliableValueText>
            <AvaliableValueTextBold>{advanceTariff}</AvaliableValueTextBold>
          </MobileTarrifDiv>
          <MobileTarrifDiv>
            <AvaliableValueText>Custo:</AvaliableValueText>
            <AvaliableValueTextBold>{priceOfAdvance}</AvaliableValueTextBold>
          </MobileTarrifDiv>
        </CenterTextDiv>
      </AdvanceMobileBox>
      <ControlFooterDiv isSimulation={isSimulation}>
        <DashboardDivisor
          marginTop={0}
          marginBottom={0}
          marginTopMobile={0}
          marginBottomMobile={0}
          color={GRAY_SCALE_08}
        />
        <AdvanceControlsMobileBox>
          <TermsAndConditionLabel>
            <TermsAndConditionInput
              type="checkbox"
              name="termsAndConditions"
              checked={useFormikProps.values.termsAndConditions}
              onChange={useFormikProps.handleChange}
            />
            <TermsAndConditionTextBox>
              <TermsAndConditionText>
                Li e aceito os{' '}
                <TermsAndConditionLink onClick={() => setIsTermModal(true)}>
                  {' '}
                  termos e condições{' '}
                </TermsAndConditionLink>{' '}
                da antecipação de saldo.{' '}
              </TermsAndConditionText>
            </TermsAndConditionTextBox>
          </TermsAndConditionLabel>
          {isSimulation && (
            <SimulationMobileBox className={'advance-button-simulation-box'}>
              <DashboardhMediumButton
                type="submit"
                background={
                  disabledControl && !loading ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : ''
                }
                color={disabledControl && !loading ? WHITE : ''}
                height="52px"
                maxWidth="100%"
                variant={disabledControl && !loading ? 'outlined' : 'disabled'}
                borderRadius='100px'
              >
                {!loading && <>{'Simular'}</>}
                {loading && <Loader small={true} />}
              </DashboardhMediumButton>
            </SimulationMobileBox>
          )}
          {!isSimulation && (
            <AdvanceControlMobileBox className={'advance-button-advance-box'}>
              <DashboardhMediumButton
                onClick={() => {
                  useFormikProps.resetForm()
                  setIsSimulation(true)
                }}
                type="submit"
                height="52px"
                maxWidth="438px"
                variant={'outlined'}
              >
                {'Limpar'}
              </DashboardhMediumButton>
              <DashboardhMediumButton
                type="submit"
                background={disabledAdvanceControl ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : ''}
                color={disabledAdvanceControl ? WHITE : ''}
                height="52px"
                maxWidth="438px"
                variant={disabledAdvanceControl ? 'outlined' : 'disabled'}
                borderRadius='100px'
              >
                {!loading && <>{'Antecipar'}</>}
                {loading && <Loader small={true} />}
              </DashboardhMediumButton>
            </AdvanceControlMobileBox>
          )}
        </AdvanceControlsMobileBox>
      </ControlFooterDiv>
    </MobileContainer>
  )
}
